// Navigation only: API permissions and seller activation remain authoritative.
export const COMMERCE_PATHS = ['/warehouse', '/supply', '/shop-management'];

export function isCommercePath(pathname) {
  return COMMERCE_PATHS.some(path => pathname === path || pathname.startsWith(path + '/'));
}

export function commerceSections(role, inventoryActions = []) {
  if (role !== 'studio_owner' && !(role === 'manager' && inventoryActions.includes('read'))) return [];
  const sections = [{id: 'stock', to: '/warehouse', label: 'Magazzini'}];
  // Managers currently have access to Warehouse, not the seller routes.
  if (role === 'studio_owner') sections.push(
    {id: 'supply', to: '/supply', label: 'Supply'},
    {id: 'shop', to: '/shop-management', label: 'Shop'},
  );
  sections.push({id: 'suppliers', to: '/warehouse?tab=suppliers', label: 'Acquisti e fornitori'});
  return sections;
}

export function activeCommerceSection(pathname, search = '') {
  if (pathname === '/warehouse' || pathname.startsWith('/warehouse/')) {
    return new URLSearchParams(search).get('tab') === 'suppliers' ? 'suppliers' : 'stock';
  }
  if (pathname === '/supply' || pathname.startsWith('/supply/')) return 'supply';
  if (pathname === '/shop-management' || pathname.startsWith('/shop-management/')) return 'shop';
  return null;
}
